// GAVION custom pipeline: Paramètres → Pipeline (admins).
export const pipelineFr = {
  title: "Pipeline",
  intro:
    "Les étapes des opportunités, dans l'ordre du tableau. Gagné et Perdu restent toujours à la fin. Nouveau lead, Qualifié, Gagné et Perdu ne peuvent pas être supprimées, mais peuvent être renommées et recolorées. Un nom changé s'affiche tel quel en français et en anglais.",
  open_stages: "Étapes en cours",
  closed_stages: "Étapes de fin",
  label: "Nom de l'étape",
  color: "Couleur",
  probability: "Probabilité (%)",
  drag: "Glisser pour déplacer %{label}",
  move_up: "Monter %{label}",
  move_down: "Descendre %{label}",
  delete: "Supprimer %{label}",
  add: "Ajouter une étape",
  manage: "Gérer les étapes",
  new_stage: "Nouvelle étape",
  save: "Enregistrer",
  saved: "Pipeline enregistré",
  loading: "Chargement du pipeline…",
  deleted: "Étape supprimée",
  deleted_moved:
    "Étape supprimée : %{smart_count} opportunité déplacée |||| Étape supprimée : %{smart_count} opportunités déplacées",
  move_dialog: {
    title: "Supprimer l'étape « %{label} »",
    body: "%{smart_count} opportunité est à cette étape. La déplacer vers : |||| %{smart_count} opportunités sont à cette étape. Les déplacer vers :",
    target: "Étape de destination",
    note: "Le déplacement ne déclenche aucune automatisation ni aucun webhook. Gagné et Perdu ne sont pas proposés : ils demandent un montant ou une raison de perte.",
    confirm: "Déplacer et supprimer",
    cancel: "Annuler",
  },
  errors: {
    forbidden: "Seul un administrateur peut modifier le pipeline.",
    invalid_stages: "La liste des étapes est invalide. Rechargez la page.",
    invalid_stage_value: "Valeur d'étape invalide : %{detail}.",
    duplicate_stage: "Deux étapes ont la même valeur : %{detail}.",
    invalid_stage_label:
      "Chaque étape doit avoir un nom (60 caractères au plus).",
    invalid_stage_color: "Couleur invalide (format #rrggbb).",
    invalid_stage_probability:
      "La probabilité doit être un nombre entre 0 et 100 %.",
    missing_system_stage: "Étapes obligatoires manquantes : %{detail}.",
    stage_in_use:
      "Des opportunités sont encore à ces étapes : %{detail}. Supprimez-les une à une pour choisir où les déplacer.",
    stage_in_rules:
      "Cette étape est utilisée par des automatisations actives : %{detail}. Modifiez ou désactivez-les d'abord.",
    system_stage: "Cette étape ne peut pas être supprimée.",
    unknown_stage: "Cette étape n'existe plus. Rechargez la page.",
    invalid_move_target: "Choisissez une étape en cours comme destination.",
    unknown: "L'enregistrement a échoué. Réessayez.",
    load_failed: "Impossible de lire le pipeline. Rechargez la page.",
  },
  upstream_moved:
    "Les étapes des opportunités se gèrent dans Paramètres → Pipeline.",
};
